import { Component, OnInit } from '@angular/core';
import {environment} from "../../../environments/environment";
import {Router} from "@angular/router";

@Component({
  selector: 'app-mainheader',
  templateUrl: './mainheader.component.html',
  styleUrls: ['./mainheader.component.css']
})
export class MainheaderComponent implements OnInit {
    long_title: string;
    short_title: string;
    user_name: string;
    id: number;
    constructor(
        private router: Router
    ) {

    }

    ngOnInit() {
        this.long_title = environment.APP_NAME;
        this.short_title = environment.SHORT_APP_NAME;

        const storageData = JSON.parse(localStorage.getItem('loginuser'));
        this.user_name = storageData.name
        this.id = storageData.adminuserid
    }

    logout(){
        localStorage.removeItem('loginuser');
        this.router.navigate(['/login']);
    }
}



// WEBPACK FOOTER //
// /home/sotsys211/work/src/ecard_new/backend/src/app/layout/mainheader/mainheader.component.ts